import { useLockBodyScroll } from '../../hooks/useLockBodyScroll';
import type {
  UseToggleWithAnimationArgs,
  UseToggleWithAnimationReturn,
} from '../../hooks/useToggleWithAnimation';
import { useToggleWithAnimation } from '../../hooks/useToggleWithAnimation';

export const useDrawer = (
  args: UseToggleWithAnimationArgs
): UseToggleWithAnimationReturn & { closed: boolean } => {
  const { state, ...rest } = useToggleWithAnimation(args);

  useLockBodyScroll({ state });

  return { state, ...rest, closed: state === 'closed' };
};
